import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'
import { useTranslation } from 'react-i18next'

/**
 * @param {object} error
 * @param {Array<string>} keysToUse where to find the translation
 * @param {boolean} showErrorsshow backend errors if it has an error key
 */
const ErrorMessage = ({ error, visible, keysToUse, showErrors }) => {
  const { t } = useTranslation(['translation', 'COMMON', ...keysToUse])

  if (!error) return null

  const listErrors = (errors) => <ul>{errors.map(e => <li key={e}>{e}</li>)}</ul>

  return (
    <Alert color="danger" isOpen={visible}>
      <p>{t(`${error?.resource?.toUpperCase() || 'COMMON'}.${error.errorCode}`, error.options)}</p>
      {(showErrors && Array.isArray(error.errors)) && listErrors(error.errors)}
    </Alert>
  )
}

ErrorMessage.defaultProps = {
  keysToUse: [],
  showErrors: false
}

ErrorMessage.propTypes = {
  error: PropTypes.shape({
    errorCode: PropTypes.string.isRequired, // key error
    resource: PropTypes.string, // key to find a message
    errors: PropTypes.arrayOf(PropTypes.string), // backend errors
    options: PropTypes.object, // t options
  }),
}

export default ErrorMessage
